import Api from '../lib/api';

export class UploadService extends Api {
  constructor(companyId: number) {
    super(`upload/${companyId}`);
  }
}
